import gql from 'graphql-tag'

export const ADD_PRODUCT_IN_STOCK_NOTIFICATION = gql`
     mutation AddWatchedProduct($invMastUid: Int, $firstName: String, $lastName: String, $emailAddress: String) {
        addWatchedProduct(
            invMastUid: $invMastUid
            firstName: $firstName
            lastName: $lastName
            emailAddress: $emailAddress
        ) {
            success
            message
            logId
        }
    }
`

export const CANCEL_PRODUCT_IN_STOCK_NOTIFICATION = gql`
     mutation CancelWatchedProduct($invMastUid: Int) {
        cancelWatchedProduct(invMastUid: $invMastUid) {
            success
            message
            logId
        }
    }
`

export const GET_PRODUCT_IN_STOCK_NOTIFICATIONS = gql`
     query GetWatchedProductList {
        getWatchedProductList {
            id
            entryDate
            invMastUid
            itemId
            itemImage {
                altText
                path
            }
        }
    }
`

